import { Component, Input } from '@angular/core';
import { ServiceTemplateStatus } from '../../../../core/models/service-template/service-template.model';

@Component({
  selector: 'irembogov-service-template-status-badge',
  templateUrl: './service-template-status-badge.component.html',
  styleUrls: ['./service-template-status-badge.component.scss'],
})
export class ServiceTemplateStatusBadgeComponent {
  @Input() status!: ServiceTemplateStatus;

  ServiceTemplateStatus = ServiceTemplateStatus;

  get statusConfig() {
    switch (this.status) {
      case ServiceTemplateStatus.DRAFT:
        return {
          class: 'badge-draft',
          icon: 'fas fa-edit',
          label: 'Draft',
        };
      case ServiceTemplateStatus.PUBLISHED:
        return {
          class: 'badge-published',
          icon: 'fas fa-check-circle',
          label: 'Published',
        };
      default:
        return {
          class: 'badge-unknown',
          icon: 'fas fa-question-circle',
          label: 'Unknown',
        };
    }
  }
}
